module.exports = __webpack_public_path__ + "static/1-63ca17e0df3e1a397c0626d05d0b99be.gif";